var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.992,
    height: 18.983,
    viewBox: "0 0 18.992 18.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160669",
    "data-name": "Group 160669",
    transform: "translate(-408.056 -415.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160586",
    "data-name": "Group 160586",
    transform: "translate(408.421 416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reports_Outline_24px",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1126",
    "data-name": "Rectangle 1126",
    width: 18,
    height: 18,
    transform: "translate(0)",
    fill: "#ffecd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 18,
    height: 18,
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    d: "M9.256,5.28a7.4,7.4,0,1,0,7.4,7.4h-7.4Z",
    transform: "translate(-1.474 -2.202)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    d: "M17.574,3.056A7.353,7.353,0,0,0,13.63,1.92h0v7.4h7.4a7.35,7.35,0,0,0-.942-3.61",
    transform: "translate(-3.148 -1.534)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 0.502,
    cy: 0.502,
    r: 0.502,
    transform: "translate(15.316 2.34)",
    fill: "#165cf3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsDarkIcon);
export default __webpack_public_path__ + "static/media/reports-dark-icon.3f637e0b2ce4d8d9c76069442d11cd78.svg";
export { ForwardRef as ReactComponent };